import React from 'react';
import { store } from '../../store'
import TilbodNavigation from '../tilbod-navigation'
import Tab from 'react-bootstrap/Tab'
import TabContainer from 'react-bootstrap/TabContainer'
import TabContent from 'react-bootstrap/TabContent'
import Nav from 'react-bootstrap/Nav'
import { customerNameById, formatKennitala, isBeneficiaryValid, isBeneficiaryValidForCustomer, singlePayerConfirmed, shouldShowPayerEmployerCheckmark, getDescriptiveContractName } from '../../utils'
import { SvgArrowIcon, SvgCheckIcon } from '../svg';
import { mapProductToPayer } from '../../api/payers/actions'
import { createEmployer, removeEmployer } from '../../api/employers/actions'
import connectWithStore from '../../utils/store'
import { setInfoKey } from '../../api/information-collection/actions'

import { offerTypesForBeneficiaries } from '../../constants'

import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import DeathbenefitsBeneficiary from "../deathbenefits-beneficiary";
const kennitala = require('kennitala')
import Modal from 'react-modal';
import { PayerModal } from '../modals'
import { EmployerModal } from '../modals'



class TilbodStepPayment extends React.Component {

    constructor(props) {
        super(props)

        this.onEditComment = this.onEditComment.bind(this)
        this.checkVidStatus = this.checkVidStatus.bind(this)
        this.onCheckBox = this.onCheckBox.bind(this)
        this.commentFocus = this.commentFocus.bind(this)
        this.commentFocusOut = this.commentFocusOut.bind(this)
    }

    onCheckBox(key, value, customerId) {
        this.props.dispatch(setInfoKey({ key, value}, customerId))
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    commentFocus(event) {
        let $element = $(event.target);
        if (!$element.hasClass('focused') ) {
            $element.parent().siblings('label').addClass('focused');
        }
    }

    commentFocusOut(event) {
        let $element = $(event.target);
        if ($element.val().trim()==='') {
            $element.parent().siblings('label').removeClass('focused');
        }
    }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.step .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    selectPayer(customerId, productCode, e) {
        let val = e.target.value;

        if (val === "add-payer") {
            $('#PayerModal').modal('show');
        } else {
            this.props.dispatch(mapProductToPayer(customerId, productCode, val))
        }
    }

    renderPayerNameAndType(payer) {
        let name = payer.nationalRegistryInfo.Name
        let gm = ''
        switch (payer.gm.type) {
            case "credit-card":
                gm = `Greiðslukort **** **** **** ${payer.gm.virtualCard.cardNumber}`
                break;
            case "deposit-slip":
                gm = "Greiðsluseðill"
                break;
            case "credit-card-manual":
                gm = "Kreditkort"
                break;
        }
        return `${name} - ${gm}`
    }

    shouldBeSelected(p, customerId, productCode) {
        let productMaping = this.props.payers.payerProductMapping[customerId]
        let selected = false;
        if (productMaping !== undefined && this.props.payers.payerProductMapping[customerId][productCode] && this.props.payers.payerProductMapping[customerId][productCode] === p) {
            selected = true
        }

        return selected
    }

    removeEmployer(customerId, employerId) {
        this.props.dispatch(removeEmployer(customerId, employerId))
    }

    onEditComment(customerId, event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, customerId))
    }

    checkVidStatus(productCode, customerId) {
        // if(productCode === "VID" && this.props.infoCollection.data[customerId]["VIDonetime"] === true){
        //     return true
        // } else if (productCode === "VID" && this.props.infoCollection.data[customerId]["VIDonetime"] === false && Object.keys(this.props.employers.employers).length !== 0){
        //     return false
        // }
        // if(productCode === "VIDT" && this.props.infoCollection.data[customerId]["VIDTonetime"] === true){
        //     return true
        // } else if (productCode === "VIDT" && this.props.infoCollection.data[customerId]["VIDTonetime"] === false && Object.keys(this.props.employers.employers).length !== 0){
        //     return false
        // }
        // return false
        return ((productCode === "VID" && this.props.infoCollection.data[customerId]["VIDonetime"] === true) || (productCode === "VIDT" && this.props.infoCollection.data[customerId]["VIDTonetime"] === true))
    }

    render() {


        return (
            <>
                <div className="row justify-content-center xs-pt-10">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10 step">
                            <Tab.Container id="base-info-collection-tabs" defaultActiveKey={Object.keys(this.props.offers.offerQueryParameters)[0]} >
                                <div className="tabs-container">
                                    <Nav variant="tabs" className="tabs w-100">
                                        {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                            <Nav.Item key={customerId}>
                                                <Nav.Link eventKey={customerId} onClick={this.onNavLinkClick.bind(this)}>
                                                    {customerNameById(customerId, this.props.customers)}<span>({formatKennitala(customerId)})</span>
                                                </Nav.Link>
                                                {singlePayerConfirmed(this.props.offers, customerId, this.props.employers, this.props.payers, this.props.infoCollection) && isBeneficiaryValidForCustomer(customerId, this.props) &&
                                                    <span className="check-icon small blue"><SvgCheckIcon /></span>
                                                }
                                            </Nav.Item>
                                        )}
                                    </Nav>
                                </div>
                                <Tab.Content className="w-100">
                                    <p className="content-title">Greiðsluupplýsingar</p>
                                    {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                        <Tab.Pane key={`payment-${customerId}`} eventKey={customerId}>
                                            <Accordion defaultActiveKey="0">
                                                {Object.keys(this.props.offers.offerQueryParameters[customerId]).filter((off) => this.props.offers.offerQueryParameters[customerId][off] === true).map((productCode) =>
                                                    <Card key={`${customerId}-${productCode}`}>
                                                        <Card.Header>
                                                            <Accordion.Toggle eventKey="0" as={Button} variant="link" className="toggle-button">

                                                                {shouldShowPayerEmployerCheckmark(this.props, productCode, customerId) &&
                                                                    <span className="check">
                                                                        <span className="check check-icon big green">
                                                                            <SvgCheckIcon />
                                                                        </span>
                                                                    </span>
                                                                }
                                                                {getDescriptiveContractName(productCode)}
                                                                {!(productCode === "VID" || productCode === "VIDE" || productCode === "VIDT" || productCode === "VIDTE") &&
                                                                    <div className="actions">
                                                                        {/* <span>Greiðsluleið:</span> */}
                                                                        {Object.entries(this.props.payers.payers).length === 0 ?
                                                                            <button className="btn btn-primary" data-toggle="modal" data-target={"#PayerModal"}>Bæta við greiðsluleið</button>
                                                                            :
                                                                            <select name="payers" id="payer-select" onChange={(e) => this.selectPayer(customerId, productCode, e)} value={(this.props.payers.payerProductMapping[customerId] && this.props.payers.payerProductMapping[customerId][productCode]) || ""} >
                                                                                {/* <option value="">Veljið greiðsluleið</option> */}
                                                                                {Object.keys(this.props.payers.payers).map((p) =>
                                                                                    // console.log(this.props.payers.payerProductMapping[customerId], p) 
                                                                                    <option key={p} value={p}>{this.renderPayerNameAndType(this.props.payers.payers[p])}</option>
                                                                                )}

                                                                                <option value="add-payer">Bæta við</option>
                                                                            </select>
                                                                        }
                                                                    </div>
                                                                }
                                                                {this.checkVidStatus(productCode, customerId) && <span className="button-span">Þarf ekki upplýsingar um launagreiðanda</span>}
                                                            </Accordion.Toggle>
                                                        </Card.Header>
                                                        {((productCode === "VID" && this.props.infoCollection.data[customerId]["VIDonetime"] === false) || (productCode === "VIDT" && this.props.infoCollection.data[customerId]["VIDTonetime"] === false)) &&
                                                            <Accordion.Collapse eventKey="0">
                                                                <Card.Body>
                                                                    <form>
                                                                        <div className="form-row align-items-center">
                                                                            <label htmlFor="payer-info" className="col-sm-6 col-form-label">Upplýsingar um {productCode === "VIDT" ? "samtryggingarsjóð" : "launagreiðanda"}</label>
                                                                            <div className="col-sm-6 text-right">
                                                                                {Object.keys(this.props.employers.employers).filter(cust => cust === customerId).map(c =>

                                                                                    <React.Fragment key={c}>
                                                                                        {Object.keys(this.props.employers.employers[c]).map(emp =>
                                                                                            <React.Fragment key={`${c}-${emp}`}> {this.props.employers.employers[c][emp].employer.contractType === productCode &&
                                                                                                <div>
                                                                                                    {formatKennitala(this.props.employers.employers[c][emp].employer.OrgId)} {this.props.employers.employers[c][emp].employer.Name} {this.props.employers.employers[c][emp].startDate} {productCode === "VID" && <button className="btn btn-danger px-3 py-1 xs-m-10" onClick={this.removeEmployer.bind(this, customerId, this.props.employers.employers[c][emp].employer.OrgId)}>Eyða</button>}
                                                                                                </div>
                                                                                            }
                                                                                            </React.Fragment>
                                                                                        )}

                                                                                    </React.Fragment>

                                                                                )}
                                                                                {productCode === "VID" && <button className="btn btn-primary xs-mr-20" data-toggle="modal" onClick={(e) => e.preventDefault()} data-target={"#EmployerModal-" + customerId}>Bæta við</button>}
                                                                            </div>
                                                                        </div>
                                                                    </form>
                                                                    {productCode === "VIDT" &&
                                                                        <>
                                                                            <div className="form-row confirmation-checkbox">
                                                                                <input name="VIDThasconfirmedspecifiedprivatepension" id={`vidt-has-confirmed-specified-private-pension-${customerId}`} type="checkbox" className="form-control px-2 text-sm-right" onChange={(e) => this.onCheckBox("VIDThasconfirmedspecifiedprivatepension", !this.props.infoCollection.data[customerId]['VIDThasconfirmedspecifiedprivatepension'], customerId)} checked={this.props.infoCollection.data[customerId]['VIDThasconfirmedspecifiedprivatepension']} />
                                                                                <label htmlFor={`vidt-has-confirmed-specified-private-pension-${customerId}`} className="col-12 col-form-label">
                                                                                    Ég staðfesti að umsækjandi er búinn að ganga frá umsókn um tilgreinda séreign hjá sínum samtryggingarsjóði.
                                                                                </label>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        }
                                                    </Card>

                                                )}
                                            </Accordion>
                                            <EmployerModal id={"EmployerModal-" + customerId} customerId={customerId} store={this.props.store} />
                                        </Tab.Pane>
                                    )}

                                    {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                        <Tab.Pane key={`beneficiary-${customerId}`} eventKey={customerId}>
                                            <Accordion defaultActiveKey="0">
                                                {Object.keys(this.props.offers.offerQueryParameters[customerId]).filter((off) => this.props.offers.offerQueryParameters[customerId][off] === true && offerTypesForBeneficiaries.includes(off)).length > 0 &&
                                                    <>
                                                        <p className="content-title">Rétthafar dánarbóta</p>
                                                        {Object.keys(this.props.offers.offerQueryParameters[customerId]).filter((off) => this.props.offers.offerQueryParameters[customerId][off] === true && offerTypesForBeneficiaries.includes(off)).map((productCode) => {
                                                            let _productCode = productCode
                                                            if (productCode === "FOR") {
                                                                _productCode = "REN"
                                                            }
                                                            return (<Card key={`${customerId}-${productCode}`}>
                                                                <Card.Header>
                                                                    <Accordion.Toggle eventKey="0" as={Button} variant="link" className="toggle-button">
                                                                        {isBeneficiaryValid(customerId, _productCode, this.props.infoCollection) &&
                                                                            <span className="check">
                                                                                <span className="check check-icon big green">
                                                                                    <SvgCheckIcon />
                                                                                </span>
                                                                            </span>
                                                                        }
                                                                        {getDescriptiveContractName(productCode)}
                                                                        <span className="arrow-toggle-button">
                                                                            <SvgArrowIcon />
                                                                        </span>
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey="0">
                                                                    <Card.Body>
                                                                        <form className="contract-form" onSubmit={event => event.preventDefault()}>
                                                                            <DeathbenefitsBeneficiary label={"Rétthafar dánarbóta"} fieldName={`${_productCode}deathbenefitsbeneficiary`} customerId={customerId} initialValues={this.props.infoCollection.data[customerId]} disabled={this.props.infoCollection.data[customerId].beneficiaryConfirm} />
                                                                        </form>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card>)
                                                        })}
                                                    </>
                                                }
                                            </Accordion>
                                        </Tab.Pane>
                                    )}


                                    <p className="content-title">Athugasemdir ráðgjafa (valfrjálst)</p>
                                    {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                        <Tab.Pane key={`comments-${customerId}`} eventKey={customerId}>
                                            <Tab.Container id="base-info-collection-tabs" defaultActiveKey={`${customerId}-${Object.keys(this.props.offers.offerQueryParameters[customerId])[0]}`} >
                                                <div className="tabs-container xs-mb-20">
                                                    <Nav variant="tabs" className="tabs w-100">
                                                        {Object.keys(this.props.offers.offerQueryParameters[customerId]).map((productCode, idx) =>
                                                            <Nav.Item key={`${customerId}-${productCode}`}>
                                                                <Nav.Link eventKey={`${customerId}-${productCode}`} onClick={this.onNavLinkClick.bind(this)}>
                                                                    {productCode}
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                        )}
                                                    </Nav>
                                                </div>
                                                <Tab.Content className="w-100">

                                                    {Object.keys(this.props.offers.offerQueryParameters[customerId]).map((productCode, idx) =>
                                                        <Tab.Pane key={`${customerId}-${productCode}`} eventKey={`${customerId}-${productCode}`}>
                                                            <form>
                                                                <div className="form-group comment">
                                                                    <label htmlFor="comment" className="">Athugasemd</label>
                                                                    <div className="col-12 p-0 mt-3 pt-1">
                                                                        <textarea id="comment" className="form-control" name={productCode + "comment"} onFocus={(e) => this.commentFocus(e)} onBlur={(e) => this.commentFocusOut(e)} value={this.props.infoCollection.data[customerId][productCode + "comment"]} onChange={(e) => this.onEditComment(customerId, e)} />
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </Tab.Pane>
                                                    )}
                                                </Tab.Content>
                                            </Tab.Container>
                                        </Tab.Pane>
                                    )}

                                </Tab.Content>
                            </Tab.Container>

                            <PayerModal id={"PayerModal"} store={this.props.store} />

                        </div>
                    </div>
                </div>
                <TilbodNavigation />
            </>
        )
    }
}

TilbodStepPayment.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
        virtualCard: {},
        payers: {},
        employers: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.virtualCard = (state.virtualCard === undefined) ? {} : state.virtualCard
    f.payers = (state.payers === undefined) ? {} : state.payers
    f.employers = (state.employers === undefined) ? {} : state.employers

    return f;
}

export default connectWithStore(store, TilbodStepPayment, mapStateToProps);
